<app-page-header icon="location_on" title="Localidades" subtitle="Listado de localidades del sistema"></app-page-header>

<app-spinner [show]="!flagLoaded" [type]="'fullscreen'" [color]="'#B1476A'" [trackColor]="'#4CA7C8'" [text]="'Cargando localidades...'" [showText]="true" [blurBackground]="true"></app-spinner>

<div *ngIf="flagLoaded" class="profile-area pb-70">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Localidades</h3>
            <br>
            <a routerLink="/localidad-alta">
                <button mat-raised-button mat-button color="primary">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon> Nueva Localidad
                </button>
            </a>
            <br>
            <hr>
            
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Localidad, provincia, zona..." autocomplete="off" #input>
            </mat-form-field>

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                    <ng-container matColumnDef="localidad">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Localidad </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.concepto || 'Sin nombre'}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="provincia">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Provincia </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.provincia || 'Sin provincia asignada'}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="zona">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Zona </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.zona || 'Sin zona asignada'}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Activa </th>
                        <td mat-cell *matCellDef="let element">
                            {{(element.activo !== undefined && element.activo !== null) ? (element.activo ? 'Si' : 'No') : 'No disponible'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <button style="margin-right: 5px;" 
                                    (click)="verLocalidad(element.id)" 
                                    type="button"
                                    title="Modificar datos de la localidad" 
                                    class="btn btn-warning"
                                    [disabled]="!element.id">
                                <i class="fas fa-edit"></i>
                            </button>
                        </td>
                    </ng-container>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="5">
                            No se encontraron localidades para "{{input.value}}"
                        </td>
                    </tr>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    
                    <tr mat-row 
                        *matRowDef="let row; columns: displayedColumns;" 
                        [class.inactive-row]="row.activo === false"
                        class="example-element-row">
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 200]"
                    showFirstLastButtons
                    aria-label="Seleccionar página de localidades">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>